module.exports = __webpack_public_path__ + "static/media/OneucMobileLogo.c8f7a17b.svg";